import {useInvite} from "~/composables/api/useInvite";
import {useAlertStore} from "~/stores/alert";

/**
 * Check if a user already accepted an invite
 */
export default defineNuxtRouteMiddleware(async (to) => {
    // Only run on invite pages
    if (!to.path.includes('/invite/')) return

    const email = to.query.email as string
    const token = to.params.token as string

    if (!email || !token) return

    const { checkInviteStatus } = useInvite()
    const alertStore = useAlertStore()

    try {
        const status = await checkInviteStatus(email, token)
        if (status?.accepted) {
            alertStore.setAlert('This invite has already been accepted. Sign in to continue.', 'info', 0)
            return navigateTo('/login')
        }
    } catch (error) {
        console.error('Error checking invite status:', error)
    }
})
